import { render } from "./TheBbStartDateSelect.vue?vue&type=template&id=0ecf77f2"
import script from "./TheBbStartDateSelect.vue?vue&type=script&lang=js"
export * from "./TheBbStartDateSelect.vue?vue&type=script&lang=js"
script.render = render

export default script